import React from 'react';

import Typography from '@pb/kit-component-typography';

import {IdpProvider} from '../../../constants';
import {providerCard, providerCardSelected, providerInfo, providerLogo} from '../select-idp.module.styl';

type ProviderCardProps = {
    provider: IdpProvider,
    selected: boolean,
    onSelect: (id: string) => void,
};

export const ProviderCard: React.FC<ProviderCardProps> = ({provider, selected, onSelect}) => {
    return (
        <div
            className={`${providerCard} ${selected ? providerCardSelected : ''}`}
            onClick={() => onSelect(provider.id)}
            role="button"
            tabIndex={0}
            onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onSelect(provider.id);
                }
            }}>
            <img className={providerLogo} src={provider.logo} alt={provider.name}/>
            <div className={providerInfo}>
                <Typography variant="heading-level-4">{provider.name}</Typography>
                <Typography variant="body-level-1">{provider.description}</Typography>
            </div>
        </div>
    );
};
